// extracted by mini-css-extract-plugin
export default {"inscriptions":"inscriptions_inscriptions__MsdjD","inscriptions__dl-csv":"inscriptions_inscriptions__dl-csv__lAqw6"};